import { Card } from '@mui/material'
import SoftButton from 'components/SoftButton'
import Footer from 'examples/Footer'
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import Swal from 'sweetalert2'
import { api } from 'utils/Api'
import DetailBox from 'utils/Detail-Box/DetailBox'
import Properties from './Properties'
import Managers from './Managers'
import Concierge from './Concierge/ConciergeData'
import { useHierarchy } from 'context/HierarchyContext'
import { showError } from 'utils/messageAlerts'

function Organization() {
    const [allOrgData, setAllOrgData] = useState([]);
    const [orgData, setOrgData] = useState({});
    const { orgId } = useHierarchy();
    const { orgCode, orgDetailTab } = useParams();
    const navigate = useNavigate();

    //data fetching logic
    useEffect(() => {
        if (allOrgData.length > 0 && orgId) {
            const selectedOrg = allOrgData.find(org => org.id === parseInt(orgId));
            if (selectedOrg) {
                setOrgData(selectedOrg);
            }
        }
    }, [allOrgData, orgId]);

    const fetchOrganizationData = async () => {
        try {
            const response = await api.su_Organiation.getSuOrgs(); // Replace with your API endpoint
            setAllOrgData(response);
        } catch (e) {
        }
    };

    useEffect(() => {
        fetchOrganizationData();
    }, []);
    
    const activeTab = orgDetailTab || "properties";

    // If URL is just /super-admin/organization → redirect to default tab
    useEffect(() => {
        if (!orgDetailTab) {
            navigate(`/super-admin/organization/${orgCode}/${activeTab}`, { replace: true });
        }
    }, [orgDetailTab, navigate, orgCode]);



    return (
        <DashboardLayout>
            <DashboardNavbar />
            <DetailBox
                title={`${orgData?.name} (${orgData.organization_code})` || "Organization Details"}
                data={orgData}
                inputs={[
                    // { label: "Organization Name", key: "name" },
                    { label: "Email Address", key: "email" },
                    { label: "Description", key: "description" },
                ]} />
            <Card
                sx={{
                    display: "flex",
                    flexDirection: "row",
                    mb: 1,
                    p: 1,
                    background: "#f5f7fa",
                    borderRadius: "10px",
                    width: "fit-content",
                }}
            >
                <SoftButton
                    onClick={() => navigate(`/super-admin/organization/${orgCode}/properties`)}
                    size="small"
                    sx={{
                        px: 3,
                        borderRadius: "8px",
                        fontWeight: 600,
                        backgroundColor: activeTab === "properties" ? "#e3f2fd" : "#ffffff",
                        color: activeTab === "properties" ? "#03a9f4" : "#9e9e9e",
                        border: "2px solid",
                        borderColor: activeTab === "properties" ? "#b3e5fc" : "#e0e0e0",
                        borderBottom: "none",
                        borderBottomLeftRadius: 0,
                        borderBottomRightRadius: 0,
                        boxShadow: activeTab === "properties" ? "0 2px 6px rgba(3,169,244,0.15)" : "none",
                        "&:hover": {
                            backgroundColor: activeTab === "properties" ? "#e1f5fe" : "#fafafa",
                        },
                    }}
                >
                    Properties
                </SoftButton>

                <SoftButton
                    onClick={() => navigate(`/super-admin/organization/${orgCode}/managers`)}
                    size="small"
                    sx={{
                        px: 3,
                        ml: 1,
                        borderRadius: "8px",
                        fontWeight: 600,
                        backgroundColor: activeTab === "managers" ? "#e3f2fd" : "#ffffff",
                        color: activeTab === "managers" ? "#03a9f4" : "#9e9e9e",
                        border: "2px solid",
                        borderColor: activeTab === "managers" ? "#b3e5fc" : "#e0e0e0",
                        borderBottom: "none",
                        borderBottomLeftRadius: 0,
                        borderBottomRightRadius: 0,
                        boxShadow: activeTab === "managers" ? "0 2px 6px rgba(3,169,244,0.15)" : "none",
                        "&:hover": {
                            backgroundColor: activeTab === "managers" ? "#e1f5fe" : "#fafafa",
                        },
                    }}
                >
                    Managers
                </SoftButton>
                <SoftButton
                    onClick={() => navigate(`/super-admin/organization/${orgCode}/concierge`)}
                    size="small"
                    sx={{
                        px: 3,
                        ml: 1,
                        borderRadius: "8px",
                        fontWeight: 600,
                        backgroundColor: activeTab === "concierge" ? "#e3f2fd" : "#ffffff",
                        color: activeTab === "concierge" ? "#03a9f4" : "#9e9e9e",
                        border: "2px solid",
                        borderColor: activeTab === "concierge" ? "#b3e5fc" : "#e0e0e0",
                        borderBottom: "none",
                        borderBottomLeftRadius: 0,
                        borderBottomRightRadius: 0,
                        boxShadow: activeTab === "concierge"
                            ? "0 2px 6px rgba(3,169,244,0.15)"
                            : "none",
                        "&:hover": {
                            backgroundColor:
                                activeTab === "concierge" ? "#e1f5fe" : "#fafafa",
                        },
                    }}
                >
                    Concierge
                </SoftButton>

            </Card>
            {/* Tab Content */}
            {activeTab === "properties" && <Properties />}
            {activeTab === "managers" && <Managers />}
            {activeTab === "concierge" && <Concierge />}
            <Footer />
        </DashboardLayout>
    )
}

export default Organization